import type { Transition } from 'motion/react'

// Motion tokens. Keep these in step with --motion-* and --ease-* in globals.css.

type Bezier = [number, number, number, number]

export const easeOut: Bezier = [0.22, 1, 0.36, 1]
export const easeIn: Bezier = [0.55, 0, 1, 0.45]

export const duration = {
    fast: 0.2,
    base: 0.3,
    slow: 0.4,
    hero: 0.7
}

export const rise = {
    sm: 12,
    md: 20
}

export const enter = (delay = 0, length = duration.slow): Transition => ({
    duration: length,
    ease: easeOut,
    delay
})

export const exit = (length = duration.fast): Transition => ({
    duration: length,
    ease: easeIn
})

export const stagger = (index: number, step = 0.05, max = 6): number => Math.min(index, max) * step
